<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!--        <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>-->
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <!--            <div class="main-icon-b" style="margin-right: 20px;">
                          <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
                          <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                            <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="c" dropdown>全部</el-dropdown-item>
                              <el-dropdown-item command="a">可用</el-dropdown-item>
                              <el-dropdown-item command="b">禁用</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>-->

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <!--            <div class="block">
                          <el-date-picker
                              size="mini"
                              v-model="queryConditionForm.timeFrameArr"
                              type="datetimerange"
                              align="right"
                              unlink-panels
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              @change="handleConditionQuery"
                              :picker-options="pickerOptions">
                          </el-date-picker>
                        </div>-->

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border>
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)"
                             header-align="center">
              <template #default="{ row }">
                <!-- 特殊处理状态列（假设prop为'state'） -->
                <template v-if="col.prop === 'state'">
                  <el-tag :type="row.bebtAmt === row.recdAmt ? 'success' : (row.recdAmt !== 0 && row.bebtAmt > row.recdAmt) ? 'warning' : 'danger'"
                          size="small"
                          effect="light"
                          :class="'status-tag status-tag-' + row.state">
                    <i :class="row.bebtAmt === row.recdAmt ? 'el-icon-success' : (row.recdAmt !== 0 && row.bebtAmt > row.recdAmt) ? 'el-icon-warning' : 'el-icon-error'"></i>
                    {{ row.bebtAmt === row.recdAmt ? '已结清' : (row.recdAmt !== 0 && row.bebtAmt > row.recdAmt) ? '部分收款' : '待收费' }}
                  </el-tag>
                </template>
                <!-- 其他列保持原样 -->
                <template v-else>
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
            >
              <template #default="{ row }" v-if="this.$store.getters.hasPermission('system:onCreditList:supplementaryPayment')">
                <el-button
                    :disabled="row.bebtAmt === row.recdAmt"
                    type="primary"
                    size="mini"
                    @click="handleOpenOnCreditDialog(row)"
                >补缴
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--选择挂账类型-->
        <el-dialog
            title="挂账补缴"
            :close-on-click-modal="false"
            :visible.sync="onCreditRepaymentDialogVisible"
            width="20%"
        >
          <el-form :model="onCreditRepaymentForm" style="margin-top: 20px">
            <el-form-item label="补缴金额:" label-width="120px" style="margin-bottom: 20px">
              <el-input v-model.number="onCreditRepaymentForm.recdAmt" size="mini" style="width: 80%"
                        type="number" :min="0" :max="onCreditRepaymentForm.recdAmt" @input="handleInput"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="display: flex;justify-content: center">
                <el-radio-group v-model="onCreditRepaymentForm.payType" size="mini">
                  <el-radio-button label="1">现金支付</el-radio-button>
                  <el-radio-button label="2">网络支付</el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-form>
          <!-- 底部按钮 -->
          <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="handleCancelOnCreditRepayment">取消</el-button>
        <el-button type="primary" size="mini" @click="handleOnCreditRepayment">确认</el-button>
      </span>
        </el-dialog>

        <el-dialog
            title="请扫描患者付款码"
            :visible.sync="payModalVisible"
            width="30%"
            :close-on-click-modal="false"
            @opened="handlePayDialogOpened"
            @closed="handlePayDialogClosed">

          <!-- 隐藏的扫码输入框 -->
          <div style="position: absolute; left: -9999px;">
            <el-input
                ref="paymentCodeInput"
                v-model="paymentCode"
                @input="handleScanComplete">
            </el-input>
          </div>

          <!-- 可视化提示区域 -->
          <div style="text-align: center; padding: 20px 0;">
            <!-- 状态1：等待扫码 -->
            <template v-if="scanStatus === 'waiting'">
              <i class="el-icon-loading" style="font-size: 40px;"></i>
              <p style="margin-top: 15px;">请使用扫码枪扫描顾客付款码</p>
            </template>

            <!-- 状态2：处理中 -->
            <template v-else-if="scanStatus === 'processing'">
              <i class="el-icon-loading" style="font-size: 40px;"></i>
              <p style="margin-top: 15px;">正在处理付款请求...</p>
            </template>

            <!-- 状态3：处理成功 -->
            <template v-else-if="scanStatus === 'success'">
              <i class="el-icon-success" style="font-size: 40px; color: #67C23A;"></i>
              <p style="margin-top: 15px;">
                付款成功！{{ countdown }}秒后自动关闭
              </p>
              <el-progress
                  :percentage="countdown * 20"
                  status="success"
                  style="width: 80%; margin: 10px auto;"
              ></el-progress>
            </template>

            <template v-else-if="scanStatus === 'error'">
              <i class="el-icon-error" style="font-size: 40px; color: #F56C6C;"></i>
              <p style="margin-top: 15px;">{{ errorMessage }}</p>
              <p style="margin-top: 10px; color: #999;">{{ countdown }}秒后重新开始扫码</p>
              <el-progress
                  :percentage="countdown * 20"
                  status="exception"
                  style="width: 80%; margin: 10px auto;"
              ></el-progress>
            </template>
          </div>
        </el-dialog>
      </div>
    </div>

    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getOnCreditPage, onCreditRepayment } from "@/api/onCredit/onCredit";
import { getSqbPaymentState, sqbPayment } from "@/api/reservation/outpatientCharge";
import { withLoading } from "@/untils/loading";

// 工厂函数：生成空的补缴表单
const getEmptyOnCreditRepaymentForm = () => ({
  id: null,
  payType: '1',
  recdAmt: null,
});

export default {
  data() {
    return {
      // 基础数据
      CatalogueName: '挂账列表',
      DropDownedName: '全部',
      iconComes: 'el-icon-byj',
      loading: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,

      queryConditionForm: {
        name: '',
        // timeFrameArr 未在模板中使用，已注释，但保留以防后续需要
        // timeFrameArr: [dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')],
        status: null,
      },

      // 模态框控制
      onCreditRepaymentDialogVisible: false,
      payModalVisible: false,

      // 补缴表单
      onCreditRepaymentForm: getEmptyOnCreditRepaymentForm(),
      currentRow: {},

      // 表格数据
      tableData: [],

      // 静态选项
      payTypeOption: [{ id: 1, label: '现金' }, { id: 2, label: '聚合支付' }],
      payStateOption: [{ id: 0, label: '待收费' }, { id: 1, label: '已收费' }],

      // 表格列配置
      tableRows: [
        { name: "收费序号", prop: "feeId", type: "" },
        { name: "健康ID", prop: "patId", type: "" },
        { name: "患者姓名", prop: "patName", type: "" },
        { name: "挂账金额", prop: "bebtAmt", type: "" },
        { name: "收款金额", prop: "recdAmt", type: "" },
        { name: "单据状态", prop: "state", type: "", op: 'payStateOption' },
        { name: "创建人", prop: "createName", type: "" },
        { name: "挂账时间", prop: "createTime", type: "" },
        { name: "补缴时间", prop: "updateTime", type: "" },
      ],

      headerBtn: [
        { search: "search", title: "搜索", type: "success", style: { marginLeft: "-20px" } },
      ],

      // 扫码支付相关
      paymentCode: '',
      scanTimer: null,
      isProcessing: false,
      scanStatus: 'waiting', // waiting|processing|success|error
      errorMessage: '付款失败,请重试',
      countdown: 5,
      countdownStartTime: 0,
      animationFrameId: null,
      orderId: null,
      _blurHandler: null,
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // 重置补缴表单
    resetOnCreditRepaymentForm() {
      this.onCreditRepaymentForm = getEmptyOnCreditRepaymentForm();
      this.currentRow = {};
    },

    // 扫码支付相关方法
    resetScanner() {
      this.scanStatus = 'waiting';
      this.paymentCode = '';
      this.countdown = 5;
      this.errorMessage = '付款失败，请重试';
      cancelAnimationFrame(this.animationFrameId);
      this.$nextTick(() => {
        const input = this.$refs.paymentCodeInput?.$el?.querySelector('input');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    handlePayDialogOpened() {
      this.resetScanner();
      this.$nextTick(() => {
        const input = this.$refs.paymentCodeInput;
        if (input) {
          input.focus();
          input.$el.querySelector('input').focus();
          this._blurHandler = () => {
            setTimeout(() => input.$el.querySelector('input').focus(), 10);
          };
          input.$el.querySelector('input').addEventListener('blur', this._blurHandler);
        }
      });
    },

    handlePayDialogClosed() {
      this.resetScanner();
      if (this._blurHandler) {
        this.$refs.paymentCodeInput?.$el
            .querySelector('input')
            .removeEventListener('blur', this._blurHandler);
        this._blurHandler = null;
      }
    },

    handleScanComplete(val) {
      clearTimeout(this.scanTimer);
      this.scanTimer = setTimeout(() => {
        val = val.trim();
        if (!val) return;

        const isAlipay = /^(25|26|27|28|29|30)\d{14,22}$/.test(val);
        const isWechat = /^(10|11|12|13|14|15)\d{16}$/.test(val);

        if (!isAlipay && !isWechat) {
          this.$message.error('付款码格式错误');
          this.errorMessage = '付款码格式错误';
          this.scanStatus = 'error';
          this.paymentCode = '';
          this.startCountdown();
          return;
        }
        this.processPayment(val);
      }, 300);
    },

    async processPayment(code) {
      this.scanStatus = 'processing';
      try {
        const res = await sqbPayment({ dynamicId: code, orderId: this.orderId });
        if (res.data === 'PAY_SUCCESS') {
          this.scanStatus = 'success';
          this.startCountdown();
        } else if (res.data === 'PAY_IN_PROGRESS') {
          await this.pollPaymentStatus(20);
        } else if (res.data === 'PAY_ERROR') {
          this.scanStatus = 'error';
          this.handlePaymentError();
        }
        if (res.code !== 200) this.$message.error(res.message);
      } catch (error) {
        this.handlePaymentError();
      }
    },

    async pollPaymentStatus(maxAttempts) {
      let attempts = 0;
      const pollInterval = 2000;
      const poll = async () => {
        attempts++;
        try {
          const res = await getSqbPaymentState({ orderId: this.orderId });
          if (res.data === 'PAY_SUCCESS') {
            this.scanStatus = 'success';
            this.startCountdown();
          } else if (res.data === 'PAY_ERROR' || attempts >= maxAttempts) {
            this.scanStatus = 'error';
            this.handlePaymentError();
          } else if (attempts < maxAttempts) {
            setTimeout(poll, pollInterval);
          }
        } catch {
          this.handlePaymentError();
        }
      };
      await poll();
    },

    handlePaymentError() {
      this.scanStatus = 'error';
      this.startCountdown();
      this.$message.error('支付处理失败');
    },

    startCountdown() {
      cancelAnimationFrame(this.animationFrameId);
      this.countdown = 5;
      this.countdownStartTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - this.countdownStartTime;
        const remaining = Math.max(0, 5 - Math.floor(elapsed / 1000));
        this.countdown = remaining;
        if (remaining > 0) {
          this.animationFrameId = requestAnimationFrame(animate);
        } else {
          if (this.scanStatus === 'success') {
            this.handleCancelOnCreditRepayment();
          }
          this.resetScanner();
        }
      };
      this.animationFrameId = requestAnimationFrame(animate);
    },

    // 补缴金额输入校验
    handleInput(value) {
      const maxAmount = this.currentRow.bebtAmt - this.currentRow.recdAmt;
      if (value > maxAmount) {
        this.$nextTick(() => {
          this.onCreditRepaymentForm.recdAmt = maxAmount;
          this.$message.warning("输入补缴金额不能超过挂账金额");
        });
      } else if (value < 0) {
        this.$nextTick(() => {
          this.onCreditRepaymentForm.recdAmt = 0;
          this.$message.warning("输入补缴金额不能小于0");
        });
      }
    },

    // 打开补缴对话框
    handleOpenOnCreditDialog(row) {
      this.onCreditRepaymentForm = JSON.parse(JSON.stringify(row));
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.onCreditRepaymentForm.recdAmt = row.bebtAmt - row.recdAmt;
      this.onCreditRepaymentDialogVisible = true;
    },

    // 取消/关闭补缴对话框
    handleCancelOnCreditRepayment() {
      this.resetOnCreditRepaymentForm();
      this.orderId = null;
      this.paymentCode = '';
      this.payModalVisible = false;
      this.onCreditRepaymentDialogVisible = false;
    },

    // 确认补缴
    async handleOnCreditRepayment() {
      if (!this.onCreditRepaymentForm.payType) {
        return this.$message.warning("请选择补缴方式");
      }
      await withLoading(this, '数据提交中...')(async () => {
        const res = await onCreditRepayment({
          id: this.onCreditRepaymentForm.id,
          payType: parseInt(this.onCreditRepaymentForm.payType),
          recdAmt: this.onCreditRepaymentForm.recdAmt
        });
        if (res.code === 200) {
          if (parseInt(this.onCreditRepaymentForm.payType) === 2) {
            this.orderId = res.data;
            this.payModalVisible = true;
            return;
          }
          this.handleCancelOnCreditRepayment();
          await this.loadData();
        } else {
          this.$message.error(res.message || "系统异常:请联系管理员");
        }
      });
    },

    // 表格字段映射
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 加载数据列表
    async loadData() {
      try {
        const res = await getOnCreditPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          patName: this.queryConditionForm.name || '',
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => ({
            ...item,
            createTime: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
            updateTime: item.updateTime ? dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss') : '',
          }));
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    // 搜索按钮
    async handClick(i) {
      if (i === 0) await this.loadData();
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 列宽辅助（保留原方法）
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 80;
      const padding = 30;
      const texts = [...tableData.map(item => item?.[prop] ?? ''), label];
      const maxWidth = Math.max(...texts.map(t => this.getTextWidth(String(t)) + padding));
      return Math.max(minWidth, maxWidth);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>

<style lang="less" scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.patient-dialog {
  .el-dialog {
    /* 改为动态高度控制 */
    max-height: 70vh !important;
    height: auto !important; /* 关键修改 */
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important; /* 上移对话框位置 */
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0; /* 防止头部被压缩 */

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      padding: 8px !important;
      overflow: hidden; /* 外层隐藏滚动 */
      display: flex;
      flex-direction: column;
      min-height: 0; /* 关键修复：允许flex子项收缩 */

      .aform, .bform {
        flex: 1;
        overflow-y: auto; /* 只在表单容器内滚动 */
        margin-bottom: 5px;
        min-height: 0; /* 关键修复 */

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0; /* 关键修复 */

          .el-tabs__content {
            flex: 1;
            overflow: visible; /* 禁用嵌套滚动 */
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0; /* 防止底部被压缩 */

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  /* 小屏幕适配 */
  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

/* 极紧凑表单样式 */
/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

// 穿透
/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  // align-items: center !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

  }

  // main
  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left
    .main-left {
      .custom-tree {
        max-height: 100%; /* 设置树形菜单的最大高度为父容器的100% */
        overflow-y: auto; /* 当内容超出设定高度时显示滚动条 */
      }

      /deep/ .el-tree-node__content {
        height: 40px;
        padding-left: 0 !important;
      }

      /deep/ .el-tree-node__label {
        font-size: 12px;
      }

      width: 10%;
      height: 100%;
    }

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // feet
  .feet {
    .addmessagesBox {
      .aform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }

      .bform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }
    }

    // alert
    .messagesBox {
      .tabs {

        /deep/ .el-form-item__content {
          display: flex;

          span {
            font-size: 12px;
          }
        }

        .oneLine {
          width: 524px;
          // background-color: indianred;
        }
      }

      /deep/ .el-dialog__title {
        font-size: 12px;
      }

      /deep/ .el-table {
        font-size: 12px;
      }

    }
  }

}
</style>